import React, {useState} from 'react';
import PropTypes from 'prop-types';

import {BrandLogo, CloseIcon} from '@salesforce/retail-react-app/app/components/icons';
import {Box, Drawer, DrawerBody, DrawerContent, DrawerHeader, DrawerOverlay, IconButton, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui';

import {MegaMenuPanel} from '@amblique/king-living/app/components/mega-menu/mobile/mega-menu-panel';
import {MegaMenuSubcategoryPanel} from '@amblique/king-living/app/components/mega-menu/mobile/mega-menu-subcategory-panel';

export const MegaMenuMobile = ({
  isOpen,
  menuItems = [],
  navigationMenu,
  onClose,
  onLogoClick,
  onMyAccountClick,
  onMyQuoteClick,
  ...props
}) => {
  const [selectedCategory, setSelectedCategory] = useState(null);

  const styles = useMultiStyleConfig('MegaMenu', {isMobile: true});

  const handleArrowClick = (menuItem) => {
    setSelectedCategory(menuItem);
  };

  const handleSubcategoryBack = () => {
    setSelectedCategory(null);
  };

  const handleClose = () => {
    setSelectedCategory(null);
    onClose();
  };

  const isSubcategoryPanelOpen = !!selectedCategory;

  return (
    <Drawer
      isOpen={isOpen}
      placement="left"
      size="full"
      onClose={handleClose}
      {...props}
    >
      <DrawerOverlay />
      <DrawerContent display="flex" flexDirection="column">
        <DrawerHeader>
          <Box alignItems="center" display="flex" justifyContent="space-between">
            <IconButton
              icon={<BrandLogo {...styles.logoMobile} />}
              variant="unstyled"
              onClick={onLogoClick || handleClose}
              {...styles.logoMobileWrapper}
            />
            <IconButton
              aria-label="Close menu"
              icon={<CloseIcon />}
              variant="unstyled"
              sx={{
                'transition': 'all 0.3s ease',
                '& svg': {
                  transition: 'all 0.3s ease',
                  transform: 'rotate(90deg)',
                },
              }}
              onClick={handleClose}
            />
          </Box>
        </DrawerHeader>
        <DrawerBody flex={1} overflow="hidden" p={0} position="relative">
          <Box height="100%" position="relative" sx={{willChange: 'transform'}} width="100%">
            <MegaMenuPanel
              menuItems={menuItems}
              showFunctionalSections={!isSubcategoryPanelOpen}
              transform={isSubcategoryPanelOpen ? 'translateX(-100%)' : 'translateX(0)'}
              zIndex={isSubcategoryPanelOpen ? 1 : 2}
              onArrowClick={handleArrowClick}
              onMyAccountClick={onMyAccountClick}
              onMyQuoteClick={onMyQuoteClick}
            />
            {selectedCategory && (
              <MegaMenuSubcategoryPanel
                category={selectedCategory}
                transform={isSubcategoryPanelOpen ? 'translateX(0)' : 'translateX(100%)'}
                zIndex={3}
                onBackClick={handleSubcategoryBack}
              />
            )}
          </Box>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

MegaMenuMobile.displayName = 'MegaMenuMobile';
MegaMenuMobile.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  menuItems: PropTypes.array,
  navigationMenu: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onLogoClick: PropTypes.func,
  onMyAccountClick: PropTypes.func,
  onMyQuoteClick: PropTypes.func,
};
